import { FullscreenTypeEnums } from "Data/settings";
import { SelectInput, TextInput } from "@life-line-lab/components-react";
import { Col, Row } from "antd";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { CopyOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";

const FSAddNewForm: FC<any> = (props) => {
  const {
    input,
    error,
    options,
    handleChange,
    handleSelectChange,
    handleWhitelistChange,
    handleAddNewWhitelistRow,
    handleDeleteWhitelistRow,
    isReadonly,
    isViewConfig,
    isEditConfig,
  } = props || {};

  const { t } = useTranslation();

  const { racks = [], locations = [] } = options || {};

  const typeOptions = Object.values(FullscreenTypeEnums).map((f) => ({
    label: t(`label.${f.toLowerCase()}` as any),
    value: f,
  }));

  return (
    <div className="cvc-add-new-form">
      <div className="cvc-anf-section">
        <div className="cvc-anf-title">{t("title.description")}</div>
        <Row gutter={[0, 8]}>
          {isViewConfig && (
            <Col span={24}>
              <div className="cvc-anf-row">
                <TextInput
                  label={t("label.url")}
                  value={input?.url}
                  name="url"
                  onChange={handleChange}
                  isReadonly={true}
                />
                <span
                  className="cvc-anf-copy"
                  onClick={() =>
                    input.url && navigator.clipboard.writeText(input.url)
                  }
                >
                  <CopyOutlined style={{ fontSize: 18 }} />
                </span>
              </div>
            </Col>
          )}
          <Col span={24}>
            <SelectInput
              label={t("label.type")}
              onChange={(value) => handleSelectChange(value, "type")}
              options={typeOptions}
              value={input?.type}
              isReadonly={isReadonly || isEditConfig}
            />
          </Col>
          {input.type === FullscreenTypeEnums.RACK && (
            <Col span={24}>
              <SelectInput
                label={t("label.rack")}
                onChange={(value) => handleSelectChange(value, "rackID")}
                options={racks.map((r) => ({ label: r.name, value: r._id }))}
                value={input?.rackID}
                isReadonly={isReadonly || isEditConfig}
              />
            </Col>
          )}
          {input.type === FullscreenTypeEnums.TROLLEY && (
            <Col span={24}>
              <SelectInput
                label={t("label.location")}
                onChange={(value) =>
                  handleSelectChange(value, "servicePointID")
                }
                options={locations.map((r) => ({
                  label: r.name,
                  value: r._id,
                }))}
                value={input?.servicePointID}
                isReadonly={isReadonly || isEditConfig}
              />
            </Col>
          )}
          <Col span={24}>
            <TextInput
              label={t("label.expiry")}
              value={input?.daysToExpire}
              name="daysToExpire"
              onChange={handleChange}
              suffix={t("label.days")}
              isReadonly={isReadonly}
            />
          </Col>
        </Row>
      </div>
      {!isEmpty(input.whitelist) && (
        <div className="cvc-anf-section">
          <div className="cvc-anfs-header">
            <div className="cvc-anf-title">{t("title.whitelist")}</div>
            {!isReadonly && (
              <span
                className="cvc-btn"
                onClick={() => handleAddNewWhitelistRow()}
              >
                <PlusOutlined style={{ fontSize: 18 }} />
              </span>
            )}
          </div>
          <Row gutter={[0, 8]}>
            {input.whitelist.map((w, wIndex) => (
              <Col span={24} key={wIndex}>
                <div className="cvc-whitelist-row">
                  <TextInput
                    value={w}
                    onChange={(e) =>
                      !isReadonly &&
                      handleWhitelistChange(e.target.value, wIndex)
                    }
                    placeholder="192.168.0.2"
                    isReadonly={isReadonly}
                  />
                  {input.whitelist.length > 1 && !isReadonly && (
                    <span
                      className="cvc-btn"
                      onClick={() => handleDeleteWhitelistRow(wIndex)}
                    >
                      <DeleteOutlined style={{ fontSize: 18 }} />
                    </span>
                  )}
                </div>
              </Col>
            ))}
          </Row>
        </div>
      )}
    </div>
  );
};

export default FSAddNewForm;
